/**
 * Inline stroke-based icons used across the v3 Table toolbar.
 *
 * Having one local set (instead of mixing MUI filled icons, Tabler,
 * and ad-hoc svgs) is the only way to keep the toolbar pill visually
 * coherent. All icons:
 *   • 16×16 viewBox on 24×24 canvas
 *   • 1.75 stroke width, round line-joins, `currentColor`
 *   • drawn as composed line primitives — no filled shapes, so
 *     they pick up active/hover colouring from TableToolbarButton
 *
 * When a new toolbar action needs an icon, add it here rather than
 * reaching for MUI — the visual uniformity is the point.
 */

const sv = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export const PlusIcon = () => (
  <svg {...sv}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const RefreshIcon = () => (
  <svg {...sv}>
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);

export const ColumnsIcon = () => (
  <svg {...sv}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <line x1="15" y1="3" x2="15" y2="21" />
  </svg>
);

export const DensityIcon = () => (
  <svg {...sv}>
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="18" x2="20" y2="18" />
  </svg>
);

export const ActivityIcon = () => (
  <svg {...sv}>
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);

export const DownloadIcon = () => (
  <svg {...sv}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export const FullscreenIcon = () => (
  <svg {...sv}>
    <path d="M3 9V3h6" />
    <path d="M21 9V3h-6" />
    <path d="M3 15v6h6" />
    <path d="M21 15v6h-6" />
  </svg>
);

export const FullscreenExitIcon = () => (
  <svg {...sv}>
    <path d="M8 3v5H3" />
    <path d="M16 3v5h5" />
    <path d="M3 16h5v5" />
    <path d="M21 16h-5v5" />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg {...sv}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const XIcon = () => (
  <svg {...sv}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const CheckIcon = () => (
  <svg {...sv} strokeWidth={2.25}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
